import React, { useEffect, useState } from "react";
import Input from "../../Components/Input/Input";
import DropdownSearch from "../../Components/Input/Dropdown-Search";
import { getCall, postFormDataCall } from "../../services/apiCall";
import { makeSuccessToast, makeErrorToast } from "../../Components/Toast/Toast";
import { useNavigate } from "react-router-dom";
import { encryptor, getPayloadHash } from "../../services/helper";
import { setLocalToken } from "../../services/token";

const SignUp = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    designation: "",
    type: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    designation: "",
    type: "",
    password: "",
    confirmPassword: "",
  });

  const [pincodeArr, setPincodeArr] = useState([]);
  const [designationArr, setDesignationArr] = useState([]);

  const userType = [
    {
      label: "User",
      value: "User",
    },
    { label: "Company", value: "Company" },
  ];

  const isValidData = () => {
    let isValid = true;

    if (!data?.name) {
      isValid = false;
      setError((prev) => ({ ...prev, name: "Enter your name" }));
    } else {
      if (data?.name.length < 3) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          name: "Name should contain atleast 3 characters",
        }));
      }
    }

    if (!data?.email) {
      isValid = false;
      setError((prev) => ({ ...prev, email: "Enter your email" }));
    } else {
      if (!data?.email.includes("@")) {
        isValid = false;
        setError((prev) => ({ ...prev, email: "Enter a valid email address" }));
      }
    }

    if (!data?.phone) {
      isValid = false;
      setError((prev) => ({ ...prev, phone: "Enter your phone" }));
    } else {
      if (data.phone.length !== 10) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          phone: "Enter a valid 10 digit phone number",
        }));
      }
    }

    if (!data?.pincode) {
      isValid = false;
      setError((prev) => ({ ...prev, pincode: "Enter your pincode" }));
    } else {
      if (data.pincode.length !== 6) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          pincode: "Enter a valid pincode",
        }));
      }
    }

    if (!data?.type) {
      isValid = false;
      setError((prev) => ({ ...prev, type: "Select your type" }));
    }

    if (data?.type === "Company" && !data?.designation) {
      isValid = false;
      setError((prev) => ({ ...prev, designation: "Select your designation" }));
    }

    if (!data?.password) {
      isValid = false;
      setError((prev) => ({ ...prev, password: "Enter your password" }));
    } else {
      if (data?.password.length < 4) {
        isValid = false;
        setError((prev) => ({
          ...prev,
          password: "Password should contain atleast 4 characters",
        }));
      }
    }

    return isValid;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!isValidData()) {
      return null;
    }

    let payload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      address: "Lucknow",
      pincode: data.pincode,
      usertype: data.type?.value,
      password: data.password,
    };

    if (data.type?.value === "Company") {
      payload.designation = data.designation?.id;
    }

    const dataToSend = getPayloadHash({ data: payload });

    let response = await postFormDataCall("/signup", {}, { data: dataToSend });
    if (response.success) {
      makeSuccessToast({
        message:
          "Please verify your account. OTP has been sent to you WhatsApp.",
      });
      const raw = {
        user_id: response?.user_id,
        phone: data.phone,
      };
      const encryptedData = encryptor({ payload: raw });
      setLocalToken(encryptedData, "verification-gigz");
      navigate("/auth/verify-account");
    } else {
      makeErrorToast({ message: response?.msg });
    }
  };

  const getPincode = async () => {
    try {
      let response = await getCall("/get_pincode_data");
      if (response.status_code === 200) {
        setPincodeArr(response?.PINCODES || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDesignation = async () => {
    try {
      let response = await getCall("/get_designation");
      if (response.status_code === 200) {
        setDesignationArr(response?.DESIGNATION || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDesignation();
    getPincode();
  }, []);

  return (
    <div className="w-full h-full flex flex-col justify-start items-center">
      <h2 className="text-2xl font-bold mb-4 mr-auto">Sign Up To GIGZ</h2>

      <form className="w-full" onSubmit={submitHandler}>
        <div className="w-full flex flex-col gap-5 mb-4">
          <Input
            type="text"
            label="Name"
            value={data.name}
            setValue={(val) => {
              setData((prev) => ({ ...prev, name: val }));
            }}
            error={error.name}
            setError={() => {
              setError((prev) => ({ ...prev, name: "" }));
            }}
          />
          <Input
            type="email"
            label="Email"
            value={data.email}
            setValue={(val) => {
              setData((prev) => ({ ...prev, email: val }));
            }}
            error={error.email}
            setError={() => {
              setError((prev) => ({ ...prev, email: "" }));
            }}
          />
          <Input
            type="number"
            label="Mobile"
            value={data.phone}
            setValue={(val) => {
              setData((prev) => ({ ...prev, phone: val }));
            }}
            error={error.phone}
            setError={() => {
              setError((prev) => ({ ...prev, phone: "" }));
            }}
          />
          <Input
            type="number"
            label="Pincode"
            value={data.pincode}
            setValue={(val) => {
              setData((prev) => ({ ...prev, pincode: val }));
            }}
            error={error.pincode}
            setError={() => {
              setError((prev) => ({ ...prev, pincode: "" }));
            }}
          />

          {/* <DropdownSearch
            label="Pincode"
            value={data.pincode}
            option={pincodeArr.slice(0, 100)}
            show="pincode"
            val="pincode"
            setValue={(val) => {
              setData((prev) => ({ ...prev, pincode: val }));
            }}
          /> */}

          <DropdownSearch
            label="Type"
            value={data.type}
            option={userType}
            show="label"
            val="value"
            setValue={(val) => {
              setData((prev) => ({ ...prev, type: val }));
            }}
            error={error.type}
            setError={() => {
              setError((prev) => ({ ...prev, type: "" }));
            }}
          />

          {data?.type?.value === "Company" && (
            <DropdownSearch
              label="Designation"
              value={data.designation}
              option={designationArr}
              show="subcategory_name"
              val="id"
              setValue={(val) => {
                setData((prev) => ({ ...prev, designation: val }));
              }}
              error={error.designation}
              setError={() => {
                setError((prev) => ({ ...prev, designation: "" }));
              }}
            />
          )}

          <Input
            type="password"
            label="Password"
            value={data.password}
            setValue={(val) => {
              setData((prev) => ({ ...prev, password: val }));
            }}
            error={error.password}
            setError={() => {
              setError((prev) => ({ ...prev, password: "" }));
            }}
          />
        </div>

        <div className="flex items-center justify-between mb-4">
          <a href="#" className="text-blue-600 text-sm ml-auto">
            Forget Password?
          </a>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
        >
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default SignUp;
